/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type FC } from 'react';
import GenericErrorIllustration from '@jira/illustrations__illustrations/src/ui/adg4/brand/spots/error/components/generic-error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@jira/illustrations__illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import Button from '@atlaskit/button/button';
import EmptyState from '@atlaskit/empty-state/empty-state';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

const errorDisplayHeading = defineMessage({
	id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading',
	defaultMessage: 'We couldn’t load intent templates',
	description: 'Title for the error state that is displayed when templates fail to load',
});

const errorDisplayDescription = defineMessage({
	id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description',
	defaultMessage: 'Wait a moment and then try reloading.',
	description: 'Description for the error state that is displayed when templates fail to load',
});

const reloadNowButtonText = defineMessage({
	id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text',
	defaultMessage: 'Reload',
	description:
		'The text on the button that is displayed then the templates fail to load but can be reloaded by clicking on the button',
});

export const ErrorDisplay: FC<{ refetch: () => void }> = ({ refetch }) => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			header={formatMessage(errorDisplayHeading)}
			description={formatMessage(errorDisplayDescription)}
			renderImage={getAkEmptyStateRenderImageFn(GenericErrorIllustration)}
			imageWidth={160}
			maxImageHeight={220}
			primaryAction={
				<Button onClick={refetch} appearance="link">
					{formatMessage(reloadNowButtonText)}
				</Button>
			}
		/>
	);
};
